var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-icon',{style:(_setup.iconStyle),attrs:{"color":"grey darken-1"}},[_vm._v(" "+_vm._s(_vm.iconInfo.icon)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }